exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1wPW5{display:flex;align-items:center;justify-content:center;flex:0 0 auto;height:60px;padding:0 18px 0 30px;color:#f0f3f5;background:#3899ec}._29p2s{flex:1 1 auto;margin:0;font-family:HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:18px;font-weight:300}.fQxcn{flex:0 0 auto;width:25px;height:25px;margin-left:10px;border-radius:50%;color:inherit;font-size:9px;background:rgba(22,45,61,.2)}.fQxcn:hover{color:inherit;background:#0d487f}._2fU04{display:none}.ARSed ._2fU04{display:block;font-family:HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:16px;font-weight:300;text-align:center}._18Cdv{position:relative;height:0}._18Cdv ._29p2s{display:none}._18Cdv .WEIHe{position:absolute;top:12px;right:12px;z-index:10;background:none;font-size:16px;color:#737373}._18Cdv .WEIHe:hover{background:none}._106iE{position:relative;height:0}._106iE ._29p2s{display:none}._106iE .WEIHe{position:absolute;top:18px;right:18px;z-index:10;border-radius:50%;background:#d3edff;color:#3899ec;font-size:9px}", ""]);

// exports
exports.locals = {
	"header": "_1wPW5",
	"title": "_29p2s",
	"button": "fQxcn",
	"help-button": "_2fU04",
	"helpButton": "_2fU04",
	"help": "ARSed",
	"empty": "_18Cdv",
	"close-button": "WEIHe",
	"closeButton": "WEIHe",
	"simple": "_106iE"
};